<div class="modal active">
  <div class="modal__container modal__container--sm"  style="top: 5%;">
    <div class="fields">
      <h2>NavAids Import Options</h2>
      <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>

      <div class="fields__container">
        <form autocomplete="off"  name="ngImportCsvForm" id="importCsvForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div>
                  <div class="table-container table-container--500">
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Identifier</th>
                          <th scope="col">Name</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let el of navaidsStatus; let i = index" [ngStyle]="{'background-color': el.status != 'OK'? '#99ffff' : '' }">
                          <td>
                            {{el.identification}}
                          </td>
                          <td>{{el.name}}</td>
                          <td [ngStyle]="{'background-color': el.status == 'OK'? '#bdfd7f' : '' }">
                            {{el.status}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
          </div>
          <div class="fields__btn" style="padding: 10px 0;">
            <button type="submit" class="blue" (click)="importNavaids()">
              OK
            </button>
            <button class="gray" (click)="cancelImport()">Cancel</button>
          </div>
        </div>
        </form>

      </div>

    </div>
  </div>
</div>
